import { Component, inject, OnDestroy } from '@angular/core';

import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { Alert, AlertService } from '../../../../services/alert.service';

@Component({
  selector: 'jhi-alert',
  standalone: true,
  imports: [NgbAlertModule, CommonModule],
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnDestroy {
  readonly #alertService = inject(AlertService);
  public alerts: Alert[] = this.#alertService.get();

  public setClasses(alert: Alert): { [key: string]: boolean } {
    const classes = { 'jhi-toast': Boolean(alert.toast) };
    if (alert.position) {
      return { ...classes, [alert.position]: true };
    }
    return classes;
  }

  public ngOnDestroy(): void {
    this.#alertService.clear();
  }

  public close(alert: Alert): void {
    alert.close?.(this.alerts);
  }
}
